import React from 'react';
import { UploaderConsumer } from '../../../../Uploader';
import { CommentsConsumer } from '../../..';
import CommentAssetsComponent from '../components/CommentAssets';










const CommentAssets = ({
  assetIds,
  canAdd,
  canDelete,
  commentId,
  onFilesChange,
  isV2Design
}) =>
<UploaderConsumer>
    {({ addFileToQueue }) =>
  <CommentsConsumer>
        {({ actions: { updateComment } }) =>
    <CommentAssetsComponent
      assetIds={assetIds}
      isV2Design={isV2Design}
      addFileToQueue={addFileToQueue}
      updateComment={updateComment}
      canAdd={canAdd}
      canDelete={canDelete}
      commentId={commentId}
      onFilesChange={onFilesChange} />}


      </CommentsConsumer>}

  </UploaderConsumer>;


export default CommentAssets;